import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { LoaderWrapper } from 'src/domains/sportsbook/webview/components/meetings/loaders/MeetingsLoaders.style';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';

export const MeetingsAntePostLoader = observer('MeetingsAntePostLoader', () => {
    const common = useCommon();
    const configState = ConfigComponents.get(common).config;
    const isDarkUniverse = configState.isDarkUniverse;
    const themeVersion = isDarkUniverse ? 'light' : 'dark';

    return (
        <LoaderWrapper
            size={14}
            version={themeVersion}
        >
            <I18n
                langKey='events.ante-post.loading'
                defaultText='Loading races...'
            />
        </LoaderWrapper>
    );
});

export const MeetingsSpecialsLoader = observer('MeetingsSpecialsLoader', () => {
    const common = useCommon();
    const configState = ConfigComponents.get(common).config;
    const isDarkUniverse = configState.isDarkUniverse;
    const themeVersion = isDarkUniverse ? 'light' : 'dark';

    return (
        <LoaderWrapper
            size={14}
            version={themeVersion}
        >
            <I18n
                langKey='events.specials.loading'
                defaultText='Loading races...'
            />
        </LoaderWrapper>
    );
});
